import React from 'react';
import { useSelector } from 'react-redux';
import { ChatBox } from '@pegasus/ui-chatbox';

import { TranslateScope, Translate } from '@pegasus/translation/components';

import { useConfig } from 'client/config';
import { getCustomer, getIsLoading, getIsInitial } from '../../../shared/CustomerInfo/redux';

export const ChatBoxContainer = () => {
    const config = useConfig();
    const isCustomerLoading = useSelector(getIsLoading);
    const isInitial = useSelector(getIsInitial);
    const customer = useSelector(getCustomer);

    return (
        <TranslateScope path="chatButton">
            {!isInitial && !isCustomerLoading && (
                <ChatBox
                    customer={customer}
                    config={config}
                    offlineMessage={<Translate message="offline" />}
                    onlineMessage={<Translate message="online" />}
                />
            )}
        </TranslateScope>
    );
};
